import { Controller } from "@hotwired/stimulus"

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹"

// Estimates profit for a given investment amount on a plan's show page,
// based on the plan's participation profit rate and payout interval
// (passed in as data-*-value attributes). Purely illustrative — the
// authoritative profit calculation happens server-side at settlement.
export default class extends Controller {
  static targets = ["amount", "result"]
  static values = { rate: Number, intervalMonths: Number }

  connect() {
    this.calculate()
  }

  onInput() {
    const amount = this.parseAmount(this.amountTarget.value)
    this.amountTarget.value = amount ? this.formatFa(amount) : ""
    this.calculate()
  }

  calculate() {
    const amount = this.parseAmount(this.amountTarget.value)
    const profit = amount * (this.rateValue / 100) * (this.intervalMonthsValue / 12)
    this.resultTarget.textContent = this.formatFa(Math.round(profit))
  }

  parseAmount(raw) {
    const digits = this.toEnDigits(raw).replace(/[^\d]/g, "")
    return digits ? parseInt(digits, 10) : 0
  }

  // Input starts pre-filled with a fa_amount()-formatted value (Persian
  // digits + "٬" delimiters), and users may keep typing Persian digits —
  // JS's \d only matches ASCII 0-9, so these must be normalized first.
  toEnDigits(value) {
    return value.replace(/[۰-۹]/g, (digit) => String(FA_DIGITS.indexOf(digit)))
  }

  formatFa(value) {
    const withDelimiters = value.toLocaleString("en-US").replaceAll(",", "٬")
    return withDelimiters.replace(/[0-9]/g, (digit) => FA_DIGITS[digit])
  }
}
